/* eslint-disable no-undef */
export default {
	name: "fuel-dispensement-capture",
	props:{
		collectionCode:{
			default: null
		},
		vehicleId:{
			default: null
		}
	},
	data() {
		return {
			loading: false,
			loadingFromApi: false,
			validationIsValid: true,
			canMoveOnToNextStep: false,
			orderNumber: null,
			vehicleRegistration: null,
			orderForCollection: null,
			orderItems: [],
			vehicle: {},
			codeForCollection: null
		};
	},
	methods: {
		getVehicle(){
			this.loading = true;
			let request = {
				vehicleId: this.vehicleId
			};
			customerService.getCompanyVehicle(request).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.vehicle = successResponse.data.result;
						this.vehicleRegistration = this.vehicle.vehicleRegistration;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onValidationComplete(obj){
			console.log("onValidationComplete", obj);
			this.validationIsValid = obj.isValid;
			this.canMoveOnToNextStep = obj.isValid;
			this.orderNumber = obj.orderNumber;
			this.vehicleRegistration = obj.vehicleRegistration;
			this.orderForCollection = obj.orderCollection;
			this.orderItems = obj.orderItems;
		},
		onDispensementCompleted(){
			this.canMoveOnToNextStep = false;
			this.orderNumber = null;
			this.vehicleRegistration = null;
		},
		setBreadcrumbs() {
			var pageTitle = "Fuel Dispensement Capture";
			
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		permissionsHelper.setControlsBasedOnPermissions();
	},
	watch: {
		vehicleId: {
			handler: function () {
				if (this.vehicleId !== null && this.vehicleId > 0) {
					this.getVehicle();
				}
			},
			immediate: true,
			deep: true
		},
		collectionCode:{
			handler: function () {
				if (this.collectionCode !== null && this.collectionCode !== "") {
					this.codeForCollection = this.collectionCode;
				}
			},
			immediate: true,
			deep: true
		}
	}
};